// Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import { connect } from 'react-redux';

// Components
import Modal from '~/components/general/modal/index.jsx';

// REDUX: Actions
import { modalActions } from '~/redux/actions/modal-actions';
import { deleteUserAccount } from '~/redux/actions/profile-actions';

let afterClose;

/**
 *  A Modal that warns that he/she is about to delete their account.
 *
 * @class DeleteAccountModal
 * @extends {Component}
 */
class DeleteAccountModal extends Component {
	constructor(props) {
		super(props);
		this.onClose = this.onClose.bind(this);
		this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
	}

	/**
	 * @description Closes the window, when the user clicks on the 'cancel' button
	 * @date 2018-07-16
	 * @memberof DeleteAccountModal
	 */
	onClose() {
		modalActions.hideModal();
		this.props.dispatch(modalActions.hideModal());

		if (afterClose) {
			afterClose();
		}
	}

	/**
	 * @description Dispatches and action to delete the user account
	 * @date 2018-07-16
	 * @memberof DeleteAccountModal
	 */
	handleDeleteAccount() {
		// debugger;
		this.props.dispatch(deleteUserAccount());
	}

	render() {
		const { modalTitle, modalText, onClose } = this.props;

		return (
			<Modal modalTitle={`${modalTitle}`} onClose={onClose} large center={false}>
				<div id="delete-photo-modal">
					<main className="grid-x grid-margin-x">
						<div className="cell small-12">
							<Message>{modalText}</Message>
						</div>
					</main>
					<Footer className="grid-x grid-margin-x">
						<div className="profile-form__cta__left cell shrink">
							<button
								type="button"
								onClick={() => this.onClose()}
								className="profile-form__button profile-form__button__primary"
							>
								Cancel, Keep My Account
							</button>
						</div>
						<div className="profile-form__cta__right cell shrink">
							<button
								type="button"
								onClick={() => this.handleDeleteAccount()}
								className="profile-form__button profile-form__button__flat"
							>
								Yes, Delete My Account
							</button>
						</div>
					</Footer>
				</div>
			</Modal>
		);
	}
}
/////////////////////////
//  Styled Components //
/////////////////////////
// Some help text
const Message = styled.p`
	padding: 0;
	font-size: ${rem('16px')};
	color: ${props => props.theme.gray9};
	letter-spacing: 0;
	text-align: left;
	margin-bottom: 1.5rem;
	text-align: left;
	line-height: 1.277777778;

	@media ${props => props.theme.breakpointLarge} {
		font-size: ${rem('18px')};
	}
`;

const Footer = styled.footer`
	margin-top: ${rem('24px')};
	bottom: 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: 0;
	width: 100%;
`;

function mapStateToProps(state) {
	return {
		modalTitle: state.modal.properties.modalTitle,
		modalText: state.modal.properties.modalText,
	};
}

DeleteAccountModal.defaultProps = {
	modalTitle: 'Atenção',
};

DeleteAccountModal.propTypes = {
	modalTitle: PropTypes.string,
	onClose: PropTypes.func,
};

export default connect(mapStateToProps)(DeleteAccountModal);



// WEBPACK FOOTER //
// ./src/components/general/modal/types/delete/delete-account/index.jsx